var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24.97 25.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#325ba6;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.49,
    cy: 12.49,
    r: 12.49
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_13",
    "data-name": "Layer 13"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.49,
    cy: 12.49,
    r: 12.49
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zsHINp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.7,25.7a35,35,0,0,1-7.83-.79l-.65-.18a2,2,0,0,1-1.48-2.47A13.49,13.49,0,0,1,6.36,15.7a7.63,7.63,0,0,1,2.29-1.56.36.36,0,0,1,.44.06,4.58,4.58,0,0,0,2.57,1.05,6,6,0,0,0,3.48-.55,2.59,2.59,0,0,0,.68-.45.48.48,0,0,1,.62-.06,9.38,9.38,0,0,1,3.78,3.42,13.3,13.3,0,0,1,2,4.9A1.71,1.71,0,0,1,21,24.66a21.24,21.24,0,0,1-3.14.7c-1.7.21-3.42.29-5.14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.46,9.54A5,5,0,1,1,12.39,4.6,5,5,0,0,1,17.46,9.54Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientProfile);
export default __webpack_public_path__ + "static/media/ClientProfile.b241f02ef3920e718464037004ab7250.svg";
export { ForwardRef as ReactComponent };